import { render, staticRenderFns } from "./LicencePlates.vue?vue&type=template&id=f00c5d22&scoped=true&"
import script from "./LicencePlates.vue?vue&type=script&lang=js&"
export * from "./LicencePlates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c5d22",
  null
  
)

/* custom blocks */
import block0 from "./LicencePlates.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports